<script setup lang="ts">
  import { computed, ref, onMounted, inject } from 'vue'
  import type { AIChatSessionMessage } from '@/types/generated'
  import IconRenderer from './IconRenderer.vue'
  import VueJsonPretty from 'vue-json-pretty'
  import 'vue-json-pretty/lib/styles.css'
  import { createApp, h } from 'vue'
  import MarkdownIt from 'markdown-it'

  const props = defineProps<{
    message: AIChatSessionMessage
  }>()

  const debugPanelRef = inject('debugPanelRef')
  const showRawMessages = computed(() => debugPanelRef?.value?.showRawMessages || false)
</script>
<template>
  <div class="relative">
    <div
      v-if="showRawMessages"
      class="mb-2"
    >
      <div class="rounded-lg bg-gray-900 p-4">
        <VueJsonPretty
          :data="message.context"
          :deep="2"
          :show-double-quotes="false"
          :show-length="true"
          class="!bg-transparent"
          :showLine="false"
          :collapsed-on-click-brackets="true"
          :path-selectable="true"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
  :deep(.vjs-tree) {
    font-family:
      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
      monospace !important;
    font-size: 0.75rem !important;
    line-height: 1rem !important;
    background-color: transparent !important;
    color: rgb(229 231 235) !important;
  }

  :deep(.vjs-tree .vjs-value__string) {
    color: rgb(229 231 235) !important;
  }

  :deep(.vjs-tree .vjs-value__number) {
    color: rgb(129 140 248) !important;
  }

  :deep(.vjs-tree .vjs-value__boolean) {
    color: rgb(244 114 182) !important;
  }

  :deep(.vjs-tree .vjs-value__null) {
    color: rgb(248 113 113) !important;
  }

  :deep(.vjs-tree .vjs-key) {
    color: rgb(139 92 246) !important;
  }
</style>
